var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogOut = function SvgLogOut(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none!important",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.88 16.645c.311.13.645.195.983.193a.09.09 0 0 1 .034.114.091.091 0 0 1 0 .091 7.416 7.416 0 1 1 0-9.995.091.091 0 0 1 0 .09.091.091 0 0 1-.08 0 2.522 2.522 0 0 0-1.814.754 2.568 2.568 0 0 0-.708 1.3.273.273 0 0 1-.228.229h-4.05a2.567 2.567 0 0 0 0 5.135h4.005a.274.274 0 0 1 .273.228c.116.5.378.952.754 1.3.236.241.519.432.83.561zM20 11.988c0 .227-.09.445-.25.605l-2.282 2.282a.856.856 0 0 1-1.21-1.21l.331-.33a.297.297 0 0 0 .068-.32.285.285 0 0 0-.262-.17h-6.379a.856.856 0 1 1 0-1.712h6.379a.285.285 0 0 0 .262-.171.297.297 0 0 0-.068-.32l-.33-.33a.856.856 0 0 1 1.209-1.21l2.282 2.282c.16.16.25.378.25.604z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogOut);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "log-out.4af103afc98a39a6584bdb1300d410f2.svg";